export default function initTabs() {
    // Tab functionality
    const tabLinks = document.querySelectorAll('.tab-link');
    const contentSections = document.querySelectorAll('.p-content');
    const subjectField = document.querySelector('input[name="Subject"]'); // Subject field in the form
    const urlField = document.querySelector('input[name="URL"]'); // URL field in the form

    function showContent(targetId) {
        // Show the corresponding content section
        contentSections.forEach(section => {
            if (section.id === targetId) {
                section.classList.add('active', 'fade-in');
            } else {
                section.classList.remove('active', 'fade-in');
            }
        });

        // Update the active class on links
        tabLinks.forEach(link => {
            if (link.dataset.target === targetId) {
                link.classList.add('active');
            } else {
                link.classList.remove('active');
            }
        });
    }

    // Attach click event listeners to the links
    tabLinks.forEach(link => {
        link.addEventListener('click', function (event) {
            event.preventDefault();
            const targetId = this.dataset.target;

            // Show the tab content
            showContent(targetId);

            // Update the Subject field in the form if a dataset attribute is present
            if (this.dataset.setSubject && subjectField) {
                subjectField.value = this.dataset.setSubject;
                subjectField.readOnly = true; // Make the field read-only
            }

            // Update and make the URL field read-only if a dataset attribute is present
            if (this.dataset.setUrl && urlField) {
                urlField.value = this.dataset.setUrl;
                urlField.readOnly = true; // Make the field read-only
            }
        });
    });

    // Default to showing the first section
    // showContent('content-a');

    // File input validation functionality
    const fileInput = document.getElementById('screenshotField');
    const form = document.querySelector('form');

    if (fileInput && form) {
        form.addEventListener('submit', function (event) {
            const file = fileInput.files[0]; // Get the first file selected

            if (file) {
                const maxSize = 2 * 1024 * 1024; // 2MB in bytes
                if (file.size > maxSize) {
                    // Prevent form submission if the file is too large
                    event.preventDefault();
                    alert('The file is too large. Please upload a file smaller than 2MB.');
                }
            }
        });
    }

    // Handle opening tab via URL hash (e.g. #content-c)
    const hash = window.location.hash;
    if (hash) {
        const initialTarget = hash.substring(1);
        const matchingTab = document.querySelector(`.tab-link[data-target="${initialTarget}"]`);
        if (matchingTab) {
            showContent(initialTarget); // Show the correct tab
            matchingTab.classList.add('active'); // Highlight the nav item
        }
    }
}